'use client'

import axios from "axios";

axios.defaults.headers.common['Content-Type'] = 'application/json';

const BASE_URL = process.env.NEXT_PUBLIC_API_URL || process.env.API_URL

export const apiInstance = (config = {}) => {
  const instance = axios.create({
    baseURL: BASE_URL,
    ...config
  })

  instance.interceptors.request.use(
    (requestConfig) => {

      if (!requestConfig?.headers?.["Content-Type"]) {
        requestConfig.headers["Content-Type"] = "application/json"
      }

      if (requestConfig.data === undefined) {
        requestConfig.data = {};
      }

      return requestConfig;
    },
    (error) => Promise.reject(error)
  );


  instance.interceptors.response.use(
    response => {
      return response;
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  return instance;
}
